const locale = typeof window === "undefined" ? "en" : (window.navigator.languages[0] ?? "en");

interface FormatOptions {
  sign?: boolean;
  precision?: number;
  noSpaceBetweenValueAndUnit?: boolean;
  unit?: string | null;
}

const FORMATTERS: {
  [k: string]: Intl.NumberFormat;
} = {};

function formatter(locale: string, precision?: number) {
  const key = `${locale} - ${precision ?? ""}`;
  const formatter = FORMATTERS[key];
  if (!formatter) {
    const f = new Intl.NumberFormat(locale, {
      style: "decimal",
      maximumFractionDigits: precision,
    });
    FORMATTERS[key] = f;
    return f;
  }
  return formatter;
}

function formatNumber(
  value: number,
  { precision, noSpaceBetweenValueAndUnit = false, sign = false, unit }: FormatOptions = {},
) {
  let res;
  if (precision === undefined) {
    // for scales with small numbers near 0
    if (value !== 0 && Math.abs(value) < 0.001) {
      const e = Math.floor(Math.log10(Math.abs(value)));
      res = `${formatter(locale).format(value / Math.pow(10, e))}e${e}`;
    } else {
      res = formatter(locale).format(value);
    }
  } else {
    res = formatter(locale, precision).format(value);
  }

  res = res.replace(".", "").search(/[1-9]/) < 0 ? "0" : res;
  res = sign && res !== "0" && value > 0 ? `+${res}` : res;

  return unit ? `${res}${noSpaceBetweenValueAndUnit ? "" : " "}${unit}` : res;
}

export default formatNumber;
